import { ImageIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const DefaultCanvas = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-full text-center p-8 text-muted-foreground w-[400px]">
      <ImageIcon className="mx-auto h-12 w-12" />
      <p className="mt-4 text-sm">
        {t(
          'canvas.defaultMessage',
          'We believe that technology should be simple. To order or find out something, just write to us in the chat on the left, as if you were talking to a regular consultant.',
        )}
      </p>
    </div>
  );
};

export default DefaultCanvas;
